import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const ChevronDoubleRightIcon = forwardRef<SVGSVGElement, IconProps>(function ChevronDoubleRightIcon(
  { color = '', height = 18, width = 18, hasCursorPointer, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98851 5.45863C9.85848 5.59637 9.85848 5.8197 9.98851 5.95744L12.8607 9L9.98851 12.0426C9.85848 12.1803 9.85848 12.4036 9.98851 12.5414C10.1185 12.6791 10.3294 12.6791 10.4594 12.5414L13.567 9.2494C13.6971 9.11166 13.6971 8.88834 13.567 8.7506L10.4594 5.45863C10.3294 5.32089 10.1185 5.32089 9.98851 5.45863Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75132 5.20738C9.4903 5.48388 9.4903 5.93218 9.75132 6.20869L12.3864 9L9.75132 11.7913C9.4903 12.0678 9.4903 12.5161 9.75132 12.7926C10.0123 13.0691 10.4356 13.0691 10.6966 12.7926L13.8042 9.50066C14.0653 9.22415 14.0653 8.77585 13.8042 8.49934L10.6966 5.20738C10.4355 4.93087 10.0123 4.93087 9.75132 5.20738ZM13.1352 8.79561L13.3281 9L13.1352 9.20438C13.2165 9.08218 13.2165 8.91782 13.1352 8.79561Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.43295 5.45863C4.30292 5.59637 4.30292 5.8197 4.43295 5.95744L7.30517 9L4.43295 12.0426C4.30292 12.1803 4.30292 12.4036 4.43295 12.5414C4.56298 12.6791 4.7738 12.6791 4.90383 12.5414L8.01149 9.2494C8.14152 9.11166 8.14152 8.88834 8.01149 8.7506L4.90383 5.45863C4.7738 5.32089 4.56298 5.32089 4.43295 5.45863Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.19577 5.20738C3.93474 5.48388 3.93474 5.93218 4.19577 6.20869L6.8308 9L4.19577 11.7913C3.93474 12.0678 3.93474 12.5161 4.19577 12.7926C4.45679 13.0691 4.87999 13.0691 5.14102 12.7926L8.24868 9.50066C8.5097 9.22415 8.5097 8.77585 8.24868 8.49934L5.14102 5.20738C4.87999 4.93087 4.45679 4.93087 4.19577 5.20738ZM7.57962 8.79561L7.77256 9L7.57962 9.20438C7.66093 9.08218 7.66092 8.91782 7.57962 8.79561Z"
        fill={color || 'currentColor'}
      />
    </SvgStyled>
  );
});
